import Form from './form';
import DisplayField from './display';
import SwitchField, { Switch } from './switch';
import CheckboxField, { Checkbox } from './checkbox';
import RadioField, { Radio } from './radio';
import Error from './error';
import Label from './label';

export {
  DisplayField,
  SwitchField,
  Switch,
  CheckboxField,
  Checkbox,
  RadioField,
  Radio,
  Error,
  Label,
};

export default Form;
